export default "__VITE_ASSET__BIAtt42l__"